import { AlumniProfileModel } from '../alumni-profile/alumni-profile.model';
import { NoteTextModel, SetTextPayloadModel } from './text.model';

export enum NotePlatform {
  chimera = 'chimera',
  dex = 'dex',
}

export interface DexVideoModel {
  id: number;
  name: string;
}

export interface DexLessonModel {
  id: number;
  name: string;
  slug: string;
}

export interface DexDisciplineModel {
  id: number;
  name: string;
  slug: string;
}

export interface NoteModel {
  id: number;
  profileId: number;
  dexVideoId: number;
  dexLessonId?: number;
  dexDisciplineId?: number;
  draft?: NoteTextModel;
  latestText: NoteTextModel;
  platform?: NotePlatform;
  videoTimeStamp: number;
  originUrl?: string | null;
  createdAt?: Date;
  deletedAt?: Date;
  dexVideo?: DexVideoModel;
  dexLesson?: DexLessonModel;
  dexDiscipline?: DexDisciplineModel;
  profile?: Partial<AlumniProfileModel>;
}

export interface GroupedVideoModel {
  video: string;
  notes: NoteModel[];
}

export interface GroupedLessonModel {
  lesson: string;
  videos: GroupedVideoModel[];
}

export interface GroupedNotesModel {
  discipline: string;
  lessons: GroupedLessonModel[];
  totalNotes: number;
}

export interface SetNotePayloadModel {
  id?: number;
  dexVideoId: number;
  text: SetTextPayloadModel;
  platform?: NotePlatform;
  videoTimeStamp: number;
  deletedAt?: Date;
  dexLessonId?: number;
  dexDisciplineId?: number;
  originUrl?: string;
  saveNoteToClass?: boolean;
}
